export default function PublisherDashboard() {
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-3xl font-bold text-slate-900 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
          Publisher Dashboard
        </h1>
        <p className="text-slate-600">Coming in Phase 3</p>
      </div>
    </div>
  );
}